import { apiRequest } from './apiService';

// CRM Opportunities
export const fetchCrmOpportunities = async () => {
  return await apiRequest('/crm/opportunities', 'GET');
};
export const fetchCrmOpportunitiesById = async (opportunityId: any) => {
  return await apiRequest(`/crm/opportunities/${opportunityId}`, 'GET');
};

export const createCrmOpportunity = async (opportunityData: any) => {
  return await apiRequest('/crm/opportunities', 'POST', opportunityData);
};
export const convertCrmOpportunityToCustomer = async (opportunity_id: any) => {
  return await apiRequest(
    `/crm/opportunities/${opportunity_id}/convert`,
    'PUT'
  );
};

export const updateCrmOpportunity = async (
  opportunityId: any,
  opportunityData: any
) => {
  return await apiRequest(
    `/crm/opportunities/${opportunityId}`,
    'PUT',
    opportunityData
  );
};
